export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Guid: { input: any; output: any; }
  UInt: { input: any; output: any; }
  ULong: { input: any; output: any; }
};

/** Claim Create Input */
export type ClaimCreateInputType = {
  /** The alias of the claim */
  alias: Scalars["String"]["input"];
  /** The claim group id of the claim */
  claimGroupId: Scalars["ID"]["input"];
  /** The description of the claim */
  description: Scalars["String"]["input"];
  /** The name of the claim */
  name: Scalars["String"]["input"];
};

/** ClaimGroup Create Input */
export type ClaimGroupCreateInputType = {
  /** The active of the claim group */
  active: Scalars["Boolean"]["input"];
  /** The description of the claim group */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the claim group */
  name: Scalars["String"]["input"];
  /** The permission group id of the claim group */
  permissionGroupId: Scalars["ID"]["input"];
};

/** Mutations for ClaimGroup */
export type ClaimGroupMutations = {
  __typename?: "ClaimGroupMutations";
  create?: Maybe<CommandResult_ClaimGroup>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_ClaimGroup>;
};

/** Mutations for ClaimGroup */
export type ClaimGroupMutationsCreateArgs = {
  claimGroup: ClaimGroupCreateInputType;
};

/** Mutations for ClaimGroup */
export type ClaimGroupMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for ClaimGroup */
export type ClaimGroupMutationsUpdateArgs = {
  claimGroup: ClaimGroupUpdateInputType;
};

/** Queries for ClaimGroup */
export type ClaimGroupQueries = {
  __typename?: "ClaimGroupQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ClaimGroup>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_ClaimGroup>;
  getByID?: Maybe<CommandResult_ClaimGroup>;
};

/** Queries for ClaimGroup */
export type ClaimGroupQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ClaimGroup */
export type ClaimGroupQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ClaimGroup */
export type ClaimGroupQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type ClaimGroupType = {
  __typename?: "ClaimGroupType";
  /** The active of the claim group */
  active: Scalars["Boolean"]["output"];
  /** The alias of the claim group */
  alias: Scalars["String"]["output"];
  /** Claims */
  claims?: Maybe<Array<Maybe<ClaimType>>>;
  /** The creation date of the ClaimGroup */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the ClaimGroup */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the ClaimGroup */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the claim group */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The id of the ClaimGroup */
  id: Scalars["ID"]["output"];
  /** The name of the claim group */
  name: Scalars["String"]["output"];
  /** The order of the claim group */
  order: Scalars["Int"]["output"];
  /** Permission Group */
  permissionGroup?: Maybe<PermissionGroupType>;
  /** The permission group id of the claim group */
  permissionGroupId: Scalars["ID"]["output"];
  /** The update date of the ClaimGroup */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** ClaimGroup Update Input */
export type ClaimGroupUpdateInputType = {
  /** The active of the claim group */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The description of the claim group */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the ClaimGroup */
  id: Scalars["ID"]["input"];
  /** The name of the claim group */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The permission group id of the claim group */
  permissionGroupId: Scalars["ID"]["input"];
};

/** Mutations for Claim */
export type ClaimMutations = {
  __typename?: "ClaimMutations";
  create?: Maybe<CommandResult_Claim>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_Claim>;
};

/** Mutations for Claim */
export type ClaimMutationsCreateArgs = {
  claim: ClaimCreateInputType;
};

/** Mutations for Claim */
export type ClaimMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for Claim */
export type ClaimMutationsUpdateArgs = {
  claim: ClaimUpdateInputType;
};

/** Queries for Claim */
export type ClaimQueries = {
  __typename?: "ClaimQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Claim>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Claim>;
  getByID?: Maybe<CommandResult_Claim>;
  getMyClaimsByModule?: Maybe<EnumerableCommandResult_Claim>;
};

/** Queries for Claim */
export type ClaimQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Claim */
export type ClaimQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Claim */
export type ClaimQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

/** Queries for Claim */
export type ClaimQueriesGetMyClaimsByModuleArgs = {
  idModule: Scalars["Guid"]["input"];
};

export type ClaimType = {
  __typename?: "ClaimType";
  /** The active status of the claim */
  active: Scalars["Boolean"]["output"];
  /** The alias of the claim */
  alias: Scalars["String"]["output"];
  /** Claim Group */
  claimGroup?: Maybe<ClaimGroupType>;
  /** The claim group id of the claim */
  claimGroupId: Scalars["ID"]["output"];
  /** The creation date of the Claim */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the Claim */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the Claim */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the claim */
  description: Scalars["String"]["output"];
  /** The id of the Claim */
  id: Scalars["ID"]["output"];
  /** The name of the claim */
  name: Scalars["String"]["output"];
  /** The order of the claim */
  order: Scalars["Int"]["output"];
  /** Role Claims */
  roleClaims?: Maybe<Array<Maybe<RoleClaimType>>>;
  /** The update date of the Claim */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** USer Claims */
  userClaims?: Maybe<Array<Maybe<UserClaimType>>>;
};

/** Claim Update Input */
export type ClaimUpdateInputType = {
  /** The claim group id of the claim */
  claimGroupId: Scalars["ID"]["input"];
  /** The description of the claim */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the Claim */
  id: Scalars["ID"]["input"];
  /** The name of the claim */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The result of a command */
export type CommandResult_Claim = {
  __typename?: "CommandResult_Claim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ClaimType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ClaimGroup = {
  __typename?: "CommandResult_ClaimGroup";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ClaimGroupType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Module = {
  __typename?: "CommandResult_Module";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ModuleType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_PermissionGroup = {
  __typename?: "CommandResult_PermissionGroup";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<PermissionGroupType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Role = {
  __typename?: "CommandResult_Role";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<RoleType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_RoleClaim = {
  __typename?: "CommandResult_RoleClaim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<RoleClaimType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Tenant = {
  __typename?: "CommandResult_Tenant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<TenantType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_User = {
  __typename?: "CommandResult_User";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<UserType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_UserClaim = {
  __typename?: "CommandResult_UserClaim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<UserClaimType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_UserModuleAccess = {
  __typename?: "CommandResult_UserModuleAccess";
  errorCode?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  notifications?: Maybe<Array<Maybe<Notification>>>;
  result?: Maybe<UserModuleAccessType>;
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_UserRole = {
  __typename?: "CommandResult_UserRole";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<UserRoleType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Void = {
  __typename?: "CommandResult_Void";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

export const enum ECommandResultStatus {
  ALERT = "ALERT",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS"
}

export const enum ESort {
  ASC = "ASC",
  DESC = "DESC"
}

export const enum EWhereClausesOperators {
  CONTAINS = "CONTAINS",
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  IN = "IN",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL"
}

/** The result of a command (Enumerable) */
export type EnumerableCommandResult_Claim = {
  __typename?: "EnumerableCommandResult_Claim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<Array<Maybe<ClaimType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command (Enumerable) */
export type EnumerableCommandResult_Module = {
  __typename?: "EnumerableCommandResult_Module";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<Array<Maybe<ModuleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Claim = {
  __typename?: "ListCommandResult_Claim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ClaimType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ClaimGroup = {
  __typename?: "ListCommandResult_ClaimGroup";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ClaimGroupType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Module = {
  __typename?: "ListCommandResult_Module";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ModuleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_PermissionGroup = {
  __typename?: "ListCommandResult_PermissionGroup";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<PermissionGroupType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Role = {
  __typename?: "ListCommandResult_Role";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<RoleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_RoleClaim = {
  __typename?: "ListCommandResult_RoleClaim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<RoleClaimType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Tenant = {
  __typename?: "ListCommandResult_Tenant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<TenantType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_User = {
  __typename?: "ListCommandResult_User";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<UserType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_UserClaim = {
  __typename?: "ListCommandResult_UserClaim";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<UserClaimType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_UserRole = {
  __typename?: "ListCommandResult_UserRole";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]["output"]>;
  /** The message of the command */
  message: Scalars["String"]["output"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"]["output"];
  /** The page count of the command */
  pageCount: Scalars["UInt"]["output"];
  /** The per page of the command */
  perPage: Scalars["UInt"]["output"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<UserRoleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"]["output"];
};

/** Module Create Input */
export type ModuleCreateInputType = {
  /** The active of the module */
  active: Scalars["Boolean"]["input"];
  /** The alias of the module */
  alias: Scalars["String"]["input"];
  /** The description of the module */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the module */
  name: Scalars["String"]["input"];
};

/** Mutations for Module */
export type ModuleMutations = {
  __typename?: "ModuleMutations";
  create?: Maybe<CommandResult_Module>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_Module>;
};

/** Mutations for Module */
export type ModuleMutationsCreateArgs = {
  module: ModuleCreateInputType;
};

/** Mutations for Module */
export type ModuleMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for Module */
export type ModuleMutationsUpdateArgs = {
  module: ModuleUpdateInputType;
};

/** Queries for Module */
export type ModuleQueries = {
  __typename?: "ModuleQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Module>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Module>;
  getByID?: Maybe<CommandResult_Module>;
  getMyModules?: Maybe<EnumerableCommandResult_Module>;
};

/** Queries for Module */
export type ModuleQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Module */
export type ModuleQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Module */
export type ModuleQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type ModuleType = {
  __typename?: "ModuleType";
  /** The active of the module */
  active: Scalars["Boolean"]["output"];
  /** The alias of the module */
  alias: Scalars["String"]["output"];
  /** The creation date of the Module */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the Module */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the Module */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the module */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The id of the Module */
  id: Scalars["ID"]["output"];
  /** The name of the module */
  name: Scalars["String"]["output"];
  /** Permission Groups */
  permissionGroups?: Maybe<PermissionGroupType>;
  /** Roles */
  roles?: Maybe<RoleType>;
  /** The update date of the Module */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Module Update Input */
export type ModuleUpdateInputType = {
  /** The active of the module */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The alias of the module */
  alias: Scalars["String"]["input"];
  /** The description of the module */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the Module */
  id: Scalars["ID"]["input"];
  /** The name of the module */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Mutations for the Topcon Identity GraphQL API */
export type Mutations = {
  __typename?: "Mutations";
  claim?: Maybe<ClaimMutations>;
  claimGroup?: Maybe<ClaimGroupMutations>;
  module?: Maybe<ModuleMutations>;
  permissionGroup?: Maybe<PermissionGroupMutations>;
  role?: Maybe<RoleMutations>;
  roleClaim?: Maybe<RoleClaimMutations>;
  tenant?: Maybe<TenantMutations>;
  user?: Maybe<UserMutations>;
  userClaim?: Maybe<UserClaimMutations>;
  userRole?: Maybe<UserRoleMutations>;
};

/** Notification */
export type Notification = {
  __typename?: "Notification";
  /** The error code */
  errorCode: Scalars["String"]["output"];
  /** The error message */
  errorMessage: Scalars["String"]["output"];
  /** The property name */
  propertyName: Scalars["String"]["output"];
};

/** PermissionGroup Create Input */
export type PermissionGroupCreateInputType = {
  /** The active of the permission group */
  active: Scalars["Boolean"]["input"];
  /** The description of the permission group */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The module id of the permission group */
  moduleId: Scalars["ID"]["input"];
  /** The name of the permission group */
  name: Scalars["String"]["input"];
};

/** Mutations for PermissionGroup */
export type PermissionGroupMutations = {
  __typename?: "PermissionGroupMutations";
  create?: Maybe<CommandResult_PermissionGroup>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_PermissionGroup>;
};

/** Mutations for PermissionGroup */
export type PermissionGroupMutationsCreateArgs = {
  permissionGroup: PermissionGroupCreateInputType;
};

/** Mutations for PermissionGroup */
export type PermissionGroupMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for PermissionGroup */
export type PermissionGroupMutationsUpdateArgs = {
  permissionGroup: PermissionGroupUpdateInputType;
};

/** Queries for PermissionGroup */
export type PermissionGroupQueries = {
  __typename?: "PermissionGroupQueries";
  getAllWithPagination?: Maybe<ListCommandResult_PermissionGroup>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_PermissionGroup>;
  getByID?: Maybe<CommandResult_PermissionGroup>;
};

/** Queries for PermissionGroup */
export type PermissionGroupQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for PermissionGroup */
export type PermissionGroupQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for PermissionGroup */
export type PermissionGroupQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type PermissionGroupType = {
  __typename?: "PermissionGroupType";
  /** The active of the permission group */
  active: Scalars["Boolean"]["output"];
  /** The alias of the permission group */
  alias: Scalars["String"]["output"];
  /** Claim Groups */
  claimGroups?: Maybe<Array<Maybe<ClaimGroupType>>>;
  /** The creation date of the PermissionGroup */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the PermissionGroup */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the PermissionGroup */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the permission group */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The id of the PermissionGroup */
  id: Scalars["ID"]["output"];
  /** Module */
  module?: Maybe<ModuleType>;
  /** The module id of the permission group */
  moduleId: Scalars["ID"]["output"];
  /** The name of the permission group */
  name: Scalars["String"]["output"];
  /** The order of the permission group */
  order: Scalars["Int"]["output"];
  /** The update date of the PermissionGroup */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** PermissionGroup Update Input */
export type PermissionGroupUpdateInputType = {
  /** The active of the permission group */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The description of the permission group */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the PermissionGroup */
  id: Scalars["ID"]["input"];
  /** The module id of the permission group */
  moduleId: Scalars["ID"]["input"];
  /** The name of the permission group */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Queries for the Topcon Tech Identity API */
export type Queries = {
  __typename?: "Queries";
  claim?: Maybe<ClaimQueries>;
  claimGroup?: Maybe<ClaimGroupQueries>;
  module?: Maybe<ModuleQueries>;
  permissionGroup?: Maybe<PermissionGroupQueries>;
  role?: Maybe<RoleQueries>;
  roleClaim?: Maybe<RoleClaimQueries>;
  tenant?: Maybe<TenantQueries>;
  user?: Maybe<UserQueries>;
  userClaim?: Maybe<UserClaimQueries>;
  userRole?: Maybe<UserRoleQueries>;
};

/** RoleClaim Create Input */
export type RoleClaimCreateInputType = {
  /** The claim id of the role claim */
  claimId: Scalars["ID"]["input"];
  /** The role id of the role claim */
  roleId: Scalars["ID"]["input"];
};

/** Mutations for RoleClaim */
export type RoleClaimMutations = {
  __typename?: "RoleClaimMutations";
  create?: Maybe<CommandResult_RoleClaim>;
  delete?: Maybe<CommandResult_Void>;
  saveRoleClaims?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_RoleClaim>;
};

/** Mutations for RoleClaim */
export type RoleClaimMutationsCreateArgs = {
  roleClaim: RoleClaimCreateInputType;
};

/** Mutations for RoleClaim */
export type RoleClaimMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for RoleClaim */
export type RoleClaimMutationsSaveRoleClaimsArgs = {
  saveRoleClaimsInput: SaveRoleClaimsInput;
};

/** Mutations for RoleClaim */
export type RoleClaimMutationsUpdateArgs = {
  roleClaim: RoleClaimUpdateInputType;
};

/** Queries for RoleClaim */
export type RoleClaimQueries = {
  __typename?: "RoleClaimQueries";
  getAllWithPagination?: Maybe<ListCommandResult_RoleClaim>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_RoleClaim>;
  getByID?: Maybe<CommandResult_RoleClaim>;
};

/** Queries for RoleClaim */
export type RoleClaimQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for RoleClaim */
export type RoleClaimQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for RoleClaim */
export type RoleClaimQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type RoleClaimType = {
  __typename?: "RoleClaimType";
  /** Claim */
  claim?: Maybe<ClaimType>;
  /** The user id of the role claim */
  claimId: Scalars["ID"]["output"];
  /** The creation date of the RoleClaim */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the RoleClaim */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the RoleClaim */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The id of the RoleClaim */
  id: Scalars["ID"]["output"];
  /** Role */
  role?: Maybe<RoleType>;
  /** The role id of the role claim */
  roleId: Scalars["ID"]["output"];
  /** Tenant */
  tenant?: Maybe<TenantType>;
  /** The tenant id of the role claim */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the RoleClaim */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** RoleClaim Update Input */
export type RoleClaimUpdateInputType = {
  /** The claim id of the role claim */
  claimId: Scalars["ID"]["input"];
  /** The id of the RoleClaim */
  id: Scalars["ID"]["input"];
  /** The role id of the role claim */
  roleId: Scalars["ID"]["input"];
};

/** Role Create Input */
export type RoleCreateInputType = {
  /** The active of the role */
  active: Scalars["Boolean"]["input"];
  /** The alias of the role */
  alias: Scalars["String"]["input"];
  /** The description of the role */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The module id of the role */
  moduleId: Scalars["ID"]["input"];
  /** The name of the role */
  name: Scalars["String"]["input"];
};

/** Mutations for Role */
export type RoleMutations = {
  __typename?: "RoleMutations";
  create?: Maybe<CommandResult_Role>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_Role>;
};

/** Mutations for Role */
export type RoleMutationsCreateArgs = {
  role: RoleCreateInputType;
};

/** Mutations for Role */
export type RoleMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for Role */
export type RoleMutationsUpdateArgs = {
  roleUpdateInput: RoleUpdateInputType;
};

/** Queries for Role */
export type RoleQueries = {
  __typename?: "RoleQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Role>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Role>;
  getByID?: Maybe<CommandResult_Role>;
};

/** Queries for Role */
export type RoleQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Role */
export type RoleQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Role */
export type RoleQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type RoleType = {
  __typename?: "RoleType";
  /** The active of the role */
  active: Scalars["Boolean"]["output"];
  /** The alias of the role */
  alias: Scalars["String"]["output"];
  /** The creation date of the Role */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the Role */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the Role */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the role */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The id of the Role */
  id: Scalars["ID"]["output"];
  /** Role Module */
  module?: Maybe<ModuleType>;
  /** The module id of the role */
  moduleId: Scalars["ID"]["output"];
  /** The name of the role */
  name: Scalars["String"]["output"];
  /** The order of the role */
  order: Scalars["Int"]["output"];
  /** Role Claims */
  roleClaims?: Maybe<Array<Maybe<RoleClaimType>>>;
  /** Role Tenant */
  tenant?: Maybe<TenantType>;
  /** The tenant id of the role */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the Role */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User Roles */
  userRoles?: Maybe<Array<Maybe<UserRoleType>>>;
};

export type RoleUpdateInputType = {
  /** The active of the role */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The description of the role */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the role */
  id: Scalars["Guid"]["input"];
  /** The moduleId of the role */
  moduleId?: InputMaybe<Scalars["Guid"]["input"]>;
  /** The name of the role */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type SaveRoleClaimsInput = {
  /** The list of claim IDs */
  claims: Array<Scalars["Guid"]["input"]>;
  /** The role details */
  roleUpdateInput: RoleUpdateInputType;
  /** The list of users IDs */
  users: Array<Scalars["Guid"]["input"]>;
};

export type SaveUserClaimsInput = {
  /** The list of claim IDs */
  claims: Array<Scalars["Guid"]["input"]>;
  /** The ID of the module */
  moduleId?: InputMaybe<Scalars["Guid"]["input"]>;
  /** The list of revoked claim IDs */
  revokedClaims?: InputMaybe<Array<Scalars["Guid"]["input"]>>;
  /** The ID of the role */
  roleId?: InputMaybe<Scalars["Guid"]["input"]>;
  /** The user details */
  userUpdateInput: UserUpdateInput;
};

/** Sort input type */
export type SortClausesInputType = {
  /** The property to filter */
  field?: InputMaybe<Scalars["String"]["input"]>;
  /** The value to filter */
  sortDirection?: InputMaybe<ESort | `${ESort}`>;
};

/** Tenant Create Input */
export type TenantCreateInputType = {
  /** The active of the tenant */
  active: Scalars["Boolean"]["input"];
  /** The alias of the tenant */
  alias: Scalars["String"]["input"];
  /** The description of the tenant */
  description: Scalars["String"]["input"];
  /** The name of the tenant */
  name: Scalars["String"]["input"];
};

/** Mutations for Tenant */
export type TenantMutations = {
  __typename?: "TenantMutations";
  create?: Maybe<CommandResult_Tenant>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_Tenant>;
};

/** Mutations for Tenant */
export type TenantMutationsCreateArgs = {
  tenant: TenantCreateInputType;
};

/** Mutations for Tenant */
export type TenantMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for Tenant */
export type TenantMutationsUpdateArgs = {
  tenant: TenantUpdateInputType;
};

/** Queries for Tenant */
export type TenantQueries = {
  __typename?: "TenantQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Tenant>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Tenant>;
  getByID?: Maybe<CommandResult_Tenant>;
};

/** Queries for Tenant */
export type TenantQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Tenant */
export type TenantQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Tenant */
export type TenantQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type TenantType = {
  __typename?: "TenantType";
  /** The active of the tenant */
  active: Scalars["Boolean"]["output"];
  /** The alias of the tenant */
  alias: Scalars["String"]["output"];
  /** The creation date of the Tenant */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the Tenant */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the Tenant */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the tenant */
  description: Scalars["String"]["output"];
  /** The id of the Tenant */
  id: Scalars["ID"]["output"];
  /** The name of the tenant */
  name: Scalars["String"]["output"];
  /** Role Claims */
  roleClaims?: Maybe<Array<Maybe<RoleClaimType>>>;
  /** Roles */
  roles?: Maybe<Array<Maybe<RoleType>>>;
  /** The update date of the Tenant */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** UserRoles */
  userRoles?: Maybe<Array<Maybe<UserRoleType>>>;
  /** Users */
  users?: Maybe<Array<Maybe<UserType>>>;
};

/** Tenant Update Input */
export type TenantUpdateInputType = {
  /** The active of the tenant */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The alias of the tenant */
  alias?: InputMaybe<Scalars["String"]["input"]>;
  /** The description of the tenant */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the Tenant */
  id: Scalars["ID"]["input"];
  /** The name of the tenant */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** UserClaim Create Input */
export type UserClaimCreateInputType = {
  /** The claim id of the user claim */
  claimId: Scalars["ID"]["input"];
  /** The user id of the user claim */
  userId: Scalars["ID"]["input"];
};

/** Mutations for UserClaim */
export type UserClaimMutations = {
  __typename?: "UserClaimMutations";
  create?: Maybe<CommandResult_UserClaim>;
  delete?: Maybe<CommandResult_Void>;
  saveUserClaims?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_UserClaim>;
};

/** Mutations for UserClaim */
export type UserClaimMutationsCreateArgs = {
  userClaim: UserClaimCreateInputType;
};

/** Mutations for UserClaim */
export type UserClaimMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for UserClaim */
export type UserClaimMutationsSaveUserClaimsArgs = {
  saveUserClaimsInput: SaveUserClaimsInput;
};

/** Mutations for UserClaim */
export type UserClaimMutationsUpdateArgs = {
  userClaim: UserClaimUpdateInputType;
};

/** Mutations for UserModuleAccess */
export type UserModuleAccessMutationsCreateArgs = {
  userModuleAccess: UserModuleAccessCreateInputType;
};

/** Mutations for UserModuleAccess */
export type UserModuleAccessMutationsRevokeUserModuleAccessArgs = {
  id: Scalars["Guid"]["input"];
};

/** Queries for UserClaim */
export type UserClaimQueries = {
  __typename?: "UserClaimQueries";
  getAllWithPagination?: Maybe<ListCommandResult_UserClaim>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_UserClaim>;
  getByID?: Maybe<CommandResult_UserClaim>;
};

/** Queries for UserClaim */
export type UserClaimQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for UserClaim */
export type UserClaimQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for UserClaim */
export type UserClaimQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type UserClaimType = {
  __typename?: "UserClaimType";
  /** Claim */
  claim?: Maybe<ClaimType>;
  /** The claim id of the user claim */
  claimId: Scalars["ID"]["output"];
  /** The creation date of the UserClaim */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the UserClaim */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the UserClaim */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The id of the UserClaim */
  id: Scalars["ID"]["output"];
  /** The revoked of the user claim */
  revoked: Scalars["Boolean"]["output"];
  /** Tenant */
  tenant?: Maybe<TenantType>;
  /** The tenant id of the user claim */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the UserClaim */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User */
  user?: Maybe<UserType>;
  /** The user id of the user claim */
  userId: Scalars["ID"]["output"];
};

/** UserClaim Update Input */
export type UserClaimUpdateInputType = {
  /** The claim id of the user claim */
  claimId: Scalars["ID"]["input"];
  /** The id of the UserClaim */
  id: Scalars["ID"]["input"];
  /** The user id of the user claim */
  userId: Scalars["ID"]["input"];
};

/** Input type for creating a user */
export type UserCreateInput = {
  /** The active status of the user */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The description of the user */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The email of the user */
  email: Scalars["String"]["input"];
  /** The image URL of the user */
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The full name of the user */
  name: Scalars["String"]["input"];
  /** The password of the user */
  password?: InputMaybe<Scalars["String"]["input"]>;
  /** The position of the user */
  position?: InputMaybe<Scalars["String"]["input"]>;
  /** The role id of the user */
  roleId?: InputMaybe<Scalars["Guid"]["input"]>;
};

/** Mutations for User */
export type UserMutations = {
  __typename?: "UserMutations";
  create?: Maybe<CommandResult_User>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_User>;
  updateUserTenant?: Maybe<CommandResult_Void>;
};

/** Mutations for User */
export type UserMutationsCreateArgs = {
  userCreateInput: UserCreateInput;
};

/** Mutations for User */
export type UserMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for User */
export type UserMutationsUpdateArgs = {
  userUpdateInput: UserUpdateInput;
};

/** Mutations for User */
export type UserMutationsUpdateUserTenantArgs = {
  idB2C: Scalars["Guid"]["input"];
  tenantId: Scalars["Guid"]["input"];
};

/** Queries for User */
export type UserQueries = {
  __typename?: "UserQueries";
  getAllWithPagination?: Maybe<ListCommandResult_User>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_User>;
  getByID?: Maybe<CommandResult_User>;
};

/** Queries for User */
export type UserQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for User */
export type UserQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for User */
export type UserQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

/** UserRole Create Input */
export type UserRoleCreateInputType = {
  /** The role id of the user role */
  roleId: Scalars["ID"]["input"];
  /** The user id of the user role */
  userId: Scalars["ID"]["input"];
};

/** Mutations for UserRole */
export type UserRoleMutations = {
  __typename?: "UserRoleMutations";
  create?: Maybe<CommandResult_UserRole>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_UserRole>;
};

/** Mutations for UserRole */
export type UserRoleMutationsCreateArgs = {
  userRole: UserRoleCreateInputType;
};

/** Mutations for UserRole */
export type UserRoleMutationsDeleteArgs = {
  id: Scalars["Guid"]["input"];
  permanent?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Mutations for UserRole */
export type UserRoleMutationsUpdateArgs = {
  userRole: UserRoleUpdateInputType;
};

/** Queries for UserRole */
export type UserRoleQueries = {
  __typename?: "UserRoleQueries";
  getAllWithPagination?: Maybe<ListCommandResult_UserRole>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_UserRole>;
  getByID?: Maybe<CommandResult_UserRole>;
};

/** Queries for UserRole */
export type UserRoleQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for UserRole */
export type UserRoleQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for UserRole */
export type UserRoleQueriesGetByIdArgs = {
  id: Scalars["Guid"]["input"];
};

export type UserRoleType = {
  __typename?: "UserRoleType";
  /** The creation date of the UserRole */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the UserRole */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the UserRole */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The id of the UserRole */
  id: Scalars["ID"]["output"];
  /** User role role */
  role?: Maybe<RoleType>;
  /** The role id of the user role */
  roleId: Scalars["ID"]["output"];
  /** User role Tenant */
  tenant?: Maybe<TenantType>;
  /** The tenant id of the user role */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the UserRole */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User role user */
  user?: Maybe<UserType>;
  /** The user id of the user role */
  userId: Scalars["ID"]["output"];
};

/** UserRole Update Input */
export type UserRoleUpdateInputType = {
  /** The id of the UserRole */
  id: Scalars["ID"]["input"];
  /** The role id of the user role */
  roleId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The user id of the user role */
  userId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserType = {
  __typename?: "UserType";
  /** The active of the user */
  active: Scalars["Boolean"]["output"];
  /** The admin of the user */
  admin: Scalars["Boolean"]["output"];
  /** The creation date of the User */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the User */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the User */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The description of the user */
  description?: Maybe<Scalars["String"]["output"]>;
  /** The email of the user */
  email: Scalars["String"]["output"];
  /** The id of the User */
  id: Scalars["ID"]["output"];
  /** The id b 2 c of the user */
  idB2C: Scalars["ID"]["output"];
  /** The imageUrl of the user */
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  /** The name of the user */
  name: Scalars["String"]["output"];
  /** The position of the user */
  position: Scalars["String"]["output"];
  /** User Tenant */
  tenant?: Maybe<TenantType>;
  /** The tenant id of the user */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the User */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The user claims of the user */
  userClaims?: Maybe<Array<Maybe<UserClaimType>>>;
  /** Modules this user is allowed to enter — derived from UserModuleAccess */
  userModuleAccesses?: Maybe<Array<Maybe<UserModuleAccessType>>>;
  /** The user roles of the user */
  userRoles?: Maybe<Array<Maybe<UserRoleType>>>;
};

export type UserModuleAccessType = {
  __typename?: "UserModuleAccessType";
  /** The creation date of the UserModuleAccess */
  createdAt: Scalars["DateTime"]["output"];
  /** The deleted status of the UserModuleAccess */
  deleted: Scalars["Boolean"]["output"];
  /** The deletion date of the UserModuleAccess */
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The id of the UserModuleAccess */
  id: Scalars["ID"]["output"];
  /** Module access is granted on */
  module?: Maybe<ModuleType>;
  /** Module id of the access link */
  moduleId: Scalars["ID"]["output"];
  /** Owning tenant */
  tenant?: Maybe<TenantType>;
  /** Tenant id of the access link */
  tenantId: Scalars["ID"]["output"];
  /** The update date of the UserModuleAccess */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User granted access */
  user?: Maybe<UserType>;
  /** User id of the access link */
  userId: Scalars["ID"]["output"];
};

export type UserModuleAccessCreateInputType = {
  /** Module the user is granted access to */
  moduleId: Scalars["ID"]["input"];
  /** Target user */
  userId: Scalars["ID"]["input"];
};

/** Input type for updating a user */
export type UserUpdateInput = {
  /** The active status of the user */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The description of the user */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** The email of the user */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the user */
  id: Scalars["Guid"]["input"];
  /** The image URL of the user */
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The full name of the user */
  name: Scalars["String"]["input"];
  /** The position of the user */
  position?: InputMaybe<Scalars["String"]["input"]>;
};

/** Where clauses input type */
export type WhereClausesInputType = {
  /** The operator to filter */
  operator?: InputMaybe<EWhereClausesOperators | `${EWhereClausesOperators}`>;
  /** The property to filter */
  property?: InputMaybe<Scalars["String"]["input"]>;
  /** The value to filter */
  value?: InputMaybe<Scalars["String"]["input"]>;
};
